import React, { useRef, useEffect } from "react";

const InfiniteScroll = ({ onIntersect }) => {
    const sentinelRef = useRef(null);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "100px",
            threshold: 1.0
        };

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                onIntersect(); // Trigger the callback function when the sentinel is intersected.
            }
        }, options);

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [onIntersect]);

    return <div ref={sentinelRef} />;
};

export default InfiniteScroll;
